import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { isEmpty, masterAndChildIntersection } from '../../utils/helper'
import Multiselect from 'multiselect-react-dropdown'

const ContentPartnerModal = ({
  openModal,
  onCancel,
  roleData,
  partnerData,
  addCallback,
  editCallback,
}) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordHide, setPasswordHide] = useState(false)
  const [phone, setPhone] = useState('')
  const [subscriptionPercent, setSubscriptionPercent] = useState('')
  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedEditRoles, setSelectedEditRoles] = useState([])
  const [PPVPercent, setPPVPercent] = useState('')
  const [errorData, setErrorData] = useState({})

  useEffect(() => {
    if (!isEmpty(partnerData)) {
      handleEdit()
    }
  }, [])

  const handleEdit = () => {
    setName(partnerData?.name)
    setEmail(partnerData?.email_id)
    setPasswordHide(true)
    setPassword('TEMPSTR')
    setPhone(partnerData?.phone)
    setSubscriptionPercent(partnerData?.content_partner_revenue_share?.subscription)
    setPPVPercent(partnerData?.content_partner_revenue_share?.ppv)
    let tempRole = []
    roleData.forEach((ele) => {
      let roleIndex = partnerData.roles.findIndex((e) => e === ele._id)
      if (roleIndex > -1) {
        tempRole.push(ele)
      }
    })
    const roleIntersectionData = masterAndChildIntersection(roleData, tempRole)

    setSelectedRoles(roleIntersectionData.map((obj) => obj._id))
    setSelectedEditRoles(roleIntersectionData)
  }
  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }

  const handleSelectRoles = (info, type) => {
    let temp = selectedRoles
    if (type === 'add' && temp.indexOf(info._id) === -1) {
      temp.push(info._id)
    } else if (type === 'remove') {
      temp = temp.filter((id) => id !== info._id)
    }
    setSelectedRoles(temp)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (isEmpty(partnerData) && !name && name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name cannot be Empty!'
    }
    if (isEmpty(partnerData) && !email && email.trim().length === 0) {
      isFormValid = false
      temp.email = 'Email cannot be Empty!'
    }
    if (isEmpty(partnerData) && !password && password.trim().length === 0) {
      isFormValid = false
      temp.password = 'Password cannot be Empty!'
    }
    if (subscriptionPercent < 0 || subscriptionPercent > 100) {
      isFormValid = false
      temp.subscriptionPercent = 'Enter a Valid Input!'
    }
    if (PPVPercent < 0 || PPVPercent > 100) {
      isFormValid = false
      temp.PPVPercent = 'Enter a Valid Input!'
    }
    if (isEmpty(selectedRoles)) {
      isFormValid = false
      temp.selectedRoles = 'roles cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  console.log(roleData[0])
  const handleCreate = async () => {
    if (validateInfo()) {
      isEmpty(partnerData)
        ? addCallback({
            email_id: email,
            password: password,
            name: name,
            phone: phone,
            roles: selectedRoles,
            content_partner_revenue_share: {
              subscription: Number(subscriptionPercent),
              ppv: Number(PPVPercent),
            },
          })
        : editCallback(partnerData._id, {
            name: name,
            phone: phone,
            roles: selectedRoles,
            content_partner_revenue_share: {
              subscription: Number(subscriptionPercent),
              ppv: Number(PPVPercent),
            },
          })
    }
  }
  return (
    <CModal size="lg" visible={openModal} alignment="center">
      <CModalHeader className="px-5 py-4">
        <CModalTitle>
          {isEmpty(partnerData) ? `Add Content Partner` : `Edit Content Partner`}
        </CModalTitle>
      </CModalHeader>
      <CModalBody className="px-5 py-4">
        <CRow>
          <CCol>
            <CFormLabel>Name*</CFormLabel>
            <CFormInput
              type="text"
              value={name}
              name="name"
              onChange={(e) => handleChange(e, setName)}
            />
            <div className="message-text error-message">
              <p>{errorData.name}</p>
            </div>
          </CCol>
          <CCol>
            <CFormLabel>Phone</CFormLabel>
            <CFormInput
              type="number"
              value={phone}
              min="0"
              name="phone"
              onChange={(e) => handleChange(e, setPhone)}
            />
            <div className="message-text error-message">
              <p>{errorData.phone}</p>
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-3">
          <CCol>
            <CFormLabel>Email*</CFormLabel>
            <CFormInput
              type="email"
              value={email}
              name="email"
              onChange={(e) => handleChange(e, setEmail)}
              disabled={!isEmpty(partnerData)}
            />
            <div className="message-text error-message">
              <p>{errorData.email}</p>
            </div>
          </CCol>
          <CCol style={{ position: 'relative' }} className="">
            <CFormLabel>Password*</CFormLabel>
            <CFormInput
              type={passwordHide ? 'password' : 'text'}
              value={password}
              name="password"
              onChange={(e) => handleChange(e, setPassword)}
              disabled={!isEmpty(partnerData)}
            />
            <div
              style={{
                position: 'absolute',
                right: '5%',
                top: errorData.password || errorData.email ? '45%' : '55%',
              }}
            >
              {!passwordHide ? (
                <FontAwesomeIcon
                  icon={faEye}
                  size="lg"
                  onClick={isEmpty(partnerData) ? () => setPasswordHide(true) : ''}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faEyeSlash}
                  size="lg"
                  onClick={isEmpty(partnerData) ? () => setPasswordHide(false) : ''}
                />
              )}
            </div>
            <div className="message-text error-message">
              <p>{errorData.password}</p>
            </div>
          </CCol>
        </CRow>

        <CRow className="mt-4">
          <CCol lg="12">
            <CFormLabel>Select Roles*</CFormLabel>
            <Multiselect
              options={roleData} // Options to display in the dropdown
              selectedValues={!isEmpty(partnerData) ? selectedEditRoles : null}
              // color="red"
              style={{
                chips: {
                  background: 'blue',
                },
                searchBox: {
                  background: 'white',
                },
              }}
              showCheckbox="true"
              onSelect={(e, info) => handleSelectRoles(info, 'add')}
              onRemove={(e, info) => handleSelectRoles(info, 'remove')}
              displayValue="name"
            />
            <div className="message-text error-message">
              <p>{errorData.selectedRoles}</p>
            </div>
          </CCol>
        </CRow>

        <CRow className="mt-4">
          <CCol>
            <CFormLabel>Subscription %</CFormLabel>
            <CFormInput
              type="number"
              value={subscriptionPercent}
              min="0"
              max="100"
              name="subscriptionPercent"
              onChange={(e) => setSubscriptionPercent(Number(e.target.value))}
            />
            <div className="message-text error-message">
              <p>{errorData.subscriptionPercent}</p>
            </div>
          </CCol>
          <CCol style={{ position: 'relative' }}>
            <CFormLabel>PPV %</CFormLabel>
            <CFormInput
              type="number"
              value={PPVPercent}
              min="0"
              max="100"
              name="PPVPercent"
              onChange={(e) => setPPVPercent(Number(e.target.value))}
            />
            <div className="message-text error-message">
              <p>{errorData.PPVPercent}</p>
            </div>
          </CCol>
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton className="text-white" color="info" onClick={onCancel}>
          Cancel
        </CButton>
        <CButton className="text-white" color="info" onClick={handleCreate}>
          Submit
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ContentPartnerModal
